import React, { useState, useEffect } from 'react';
import { useIntl } from 'umi';
import { Table } from 'tea-component';
import CountriesTextHover from '../CountriesTextHover';

const { pageable, autotip } = Table.addons;

const PAGE_SIZE = 6;

// StoreRank 某日游戏在不同国家榜单中的排名列表
export default function MarketTable(props: any) {
  const { list, cloumnsLen, activeExpandedKeys } = props;
  const { formatMessage } = useIntl();

  const [tableList, setTableList] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);

  const getPaginationStateText = (): string => {
    const totalRegionsText = formatMessage({ id: 'dbi_compare_mobile_total_regions' });
    const totalNumText = tableList?.length === 1 && !tableList?.[0]?.region
      ? 0
      : tableList?.length;
    return `${totalRegionsText}: ${totalNumText}`;
  };

  useEffect(() => {
    const activeList = list.filter(
      (item: any) => item?.rank_type === activeExpandedKeys,
    );
    const tableList = activeList[0]?.region_countys;
    setTableList(tableList);
    const _columns = [];
    _columns.push({
      key: 'market',
      header: 'Countries',
      render: (cvm: any) => (
        <div style={{ paddingLeft: 24, lineHeight: '42px' }}>
          {cvm?.region || '-'}
        </div>
      ),
    });

    for (let i = 0; i < cloumnsLen; i++) {
      /** 配置columns */
      _columns.push({
        key: i,
        header: () => <>{i}</>,
        align: 'center',
        render: (cvm: any) => (
          <CountriesTextHover coutriesList={cvm[`countrys_game${i}`] || []} />
        ),
      });
    }
    // if (cloumnsLen < 6) {
    //   _columns.push({
    //     key: 'ikey',
    //     header: () => <></>,
    //     render: () => <></>,
    //   });
    // }

    setColumns(_columns);
  }, []);

  const showPagination = tableList?.length > PAGE_SIZE;

  return (
    <Table
      className="dbi-countries-table-inside"
      recordKey={() => 'market'}
      records={[...(tableList ? tableList : [])]}
      columns={[...columns]}
      hideHeader={true}
      addons={[
        autotip({
          emptyText: formatMessage({ id: 'dbi_reports_no_data' }),
        }),
        pageable({
          pageSizeOptions: [PAGE_SIZE],
          pageSizeVisible: false,
          pageIndexVisible: showPagination,
          jumpVisible: showPagination,
          endJumpVisible: showPagination,
          stateText: getPaginationStateText(),
        }),
      ]}
    />
  );
}
